var _rect, _rect2, _rect3, _rect4, _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 250,
    fill: "#1eb53a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 125,
    fill: "#0099b5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 90,
    y: 80,
    fill: "#ce1126"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 80,
    y: 85,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 40,
    r: 30,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 40,
    r: 30,
    fill: "#0099b5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    transform: "translate(136,64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M0,-6V0H3",
    transform: "rotate(18,0,-6)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    transform: "scale(-1,1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "rotate(72)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "rotate(-72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    transform: "rotate(144)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    y: -24
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    y: -48
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s3",
    x: 24
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s3",
    x: 48
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    x: -48
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    x: -24
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    x: -24,
    y: -24
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUz);
export default __webpack_public_path__ + "static/media/uz.3591058cc0de313a8ab0197891a6a290.svg";
export { ForwardRef as ReactComponent };